var React = require('react');

function IconMyPublish (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M797.5 757.8L460.7 654.2l336.8-388.6-440.4 388.6L98 550.6l829-440.4-129.5 647.6zM460.7 913.3V731.9l103.6 51.8-103.6 129.6z"}));
}

IconMyPublish.displayName = "IconMyPublish";

IconMyPublish.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconMyPublish;

IconMyPublish.default = IconMyPublish;
